module.exports = __webpack_public_path__ + "img/store-null.935d1b42.png";